import React from 'react';
import styles from './DividerLine.module.scss'

const DividerLine = () => (<div className={styles.block} />)

export default DividerLine;
